import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const total = (sums, metric) =>
    sums
        .reduce((acc, sum) => acc + sum[metric], 0.0)
        .toLocaleString(undefined, { maximumFractionDigits: 0 });

export default function MeteringSummaryCard({ title, sums, currencySymbol }) {
    const { t } = useTranslation();

    const figures = [
        [`${total(sums, "consumptionKwh")} kWh`, t("Total Consumption")],
        [`${currencySymbol} ${total(sums, "cost")}`, t("Total Cost")],
        [`${total(sums, "co2Kg")} kgCO2`, t("Total CO2")],
    ];

    return (
        <Card sx={{ mx: { xs: 2, md: 3 }, my: 2 }}>
            <CardContent>
                <Typography
                    padding={1}
                    align="left"
                    component="h2"
                    variant="h6"
                    color="primary"
                    gutterBottom
                >
                    {title}
                </Typography>
                <Grid container spacing={2}>
                    {figures.map(([value, label]) => (
                        <Grid item xs={12} md={4} key={label}>
                            <Stack
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                spacing={1}
                            >
                                <Typography variant="h4">{value}</Typography>
                                <Typography variant="subtitle2">{label}</Typography>
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
}
